import { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import { chakraComponents } from "chakra-react-select";
import TldrChakraSelect from "../../common/TldrChakraSelect";
import { defaultOptionsStyle } from "../../styled/details/stylesSelect";
import { SIZES } from "./snapshotMaker.constants";

const customComponents = {
  Option: ({ children, ...props }) => (
    <chakraComponents.Option {...props}>
      <Box display="flex" alignItems="center">
        <Box fontSize="md" width="1em" marginRight="2">
          {props.data?.icon}
        </Box>
        <Box fontSize="md">{children}</Box>
      </Box>
    </chakraComponents.Option>
  ),
  SingleValue: ({ children, ...props }) => (
    <chakraComponents.SingleValue {...props}>
      <Box display="flex" alignItems="center">
        <Box fontSize="md" width="1em" marginRight="2">
          {props.data?.icon}
        </Box>
        <Box fontSize="sm">{children}</Box>
      </Box>
    </chakraComponents.SingleValue>
  ),
  // MultiValueLabel: ({ children, ...props }) => (
  //   <chakraComponents.MultiValueLabel {...props}>
  //     <Box display="inline-flex" alignItems="center" verticalAlign="middle">
  //       <Box fontSize="md" width="1em" marginRight="2">
  //         {props.data?.icon}
  //       </Box>
  //       <Box fontSize="sm" fontWeight="normal">{children}</Box>
  //     </Box>
  //   </chakraComponents.MultiValueLabel>
  // ),
};

const SnapshotMakerSizeSettings = ({
  config = {},
  onConfigChange,
}) => {
  const { t } = useTranslation(["snapshot-maker"]);
  const options = useMemo(() => SIZES.map((item) => ({
    value: item.id,
    label: t(`size.${item.id}`),
    icon: item.icon || null,
    data: item,
  })), [t]);
  const selectedOption = useMemo(() => options.find((item) => item.value === config.id), [options, config]);
  
  const handleConfigChange = useCallback((item) => {
    onConfigChange?.(item.data);
  }, [onConfigChange]);

  return (
    <TldrChakraSelect
      chakraStyles={defaultOptionsStyle}
      styles={{
        menuPortal: (provided) => ({
          ...provided,
          zIndex: "var(--chakra-zIndices-popover)",
        }),
      }}
      menuPortalTarget={document.body}
      options={options}
      value={selectedOption}
      classNamePrefix="chakra-react-select"
      components={customComponents}
      onChange={handleConfigChange}
    />
  );
};

SnapshotMakerSizeSettings.propTypes = {
  config: PropTypes.shape({
    id: PropTypes.string,
    icon: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
      PropTypes.object,
      PropTypes.func,
    ]),
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  onConfigChange: PropTypes.func,
};

SnapshotMakerSizeSettings.defaultProps = {
  config: undefined,
  onConfigChange: undefined,
};

export default SnapshotMakerSizeSettings;
